import React from "react";
import PropTypes from "prop-types";
import BallScalePulse from "./BallScalePulse";

const ButtonLoader = ({ label }) => {
    return (
        <>
            <BallScalePulse customStyles="la-sm" />
            <span>{label}</span>
        </>
    );
};

ButtonLoader.propTypes = {
    label: PropTypes.string,
};

export default ButtonLoader;
